import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import ThemeProvider from './ThemeProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/react';
import config from './config';

if (config.sentry.DSN) {
  Sentry.init({dsn: config.sentry.DSN});
}

ReactDOM.render((
  <BrowserRouter basename="/">
    <ThemeProvider>
      <CssBaseline/>
      <App />
    </ThemeProvider>
  </BrowserRouter>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
